import { render } from "./index.vue?vue&type=template&id=8daa4bba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8daa4bba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8daa4bba"],['__file',"src/components/ResetPwdHeader/src/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8daa4bba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8daa4bba', __exports__)) {
    api.reload('8daa4bba', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=8daa4bba&scoped=true", () => {
    api.rerender('8daa4bba', render)
  })

}


export default __exports__